import(/* webpackMode: "eager" */ "/home/runner/work/full-stack-saas-mcp/full-stack-saas-mcp/src/app/vault/page.tsx");
